import React from "react";
import { LocationSearch } from "@egovernments/digit-ui-react-components";

const Map = ({formData}) => {
  const [latitude, longitude] = formData?.split(",").map(Number);
  const onChange = (pincode, position) => {
    onSelect(config?.key, position)
  }
  return (
    <div className="flex flex-col items-center justify-center h-screen">
   
<LocationSearch position={{ latitude: latitude, longitude: longitude }} onChange={onChange} />
    </div>
  );
};

export default Map;

